import { removeEntryCollectionCircularReferences } from 'lib/contentful';
import { GetStaticPropsContext, InferGetStaticPropsType } from 'next';
import { useRouter } from 'next/router';
import { useTranslation } from 'react-i18next';
import { getBlogPage } from 'repos/blogPage';
import { getAllMenuPage } from 'repos/menu';
import { getAllPosts } from 'repos/posts';

import SubscribeCTABlock from 'components/SubscribeCTABlock';
import SubscriptionForm from 'components/SubscriptionForm';
import Layout from 'components/layout';
import PostPreviews from 'components/postPreviews';
import SEO from 'components/seo';

export default function BlogPage({
  blogPage,
  posts,
  menuParams,
}: InferGetStaticPropsType<typeof getStaticProps>) {
  const { subtitle, title, ctaText } = blogPage.fields;
  const { locale } = useRouter();
  const { t } = useTranslation();
  const localizedPosts = posts.filter((post) => post.fields.locale === locale);

  return (
    <Layout menuParams={menuParams}>
      <SEO title={t('blog')} description={title} />
      <div className="bg-secondary pt-40 pb-12 text-white">
        <div className="mx-auto flex max-w-7xl flex-col items-center px-6">
          <h1 className="text-r-sm mb-4 font-extrabold uppercase tracking-wider text-primary">
            {subtitle}
          </h1>
          <h2 className="text-r-4xl mb-20 max-w-xl text-center font-bold">
            {title}
          </h2>
          <div className="relative w-full max-w-2xl">
            <div className="absolute w-full rounded-lg bg-white p-8 text-secondary shadow-2xl">
              <div className="text-r-xl mb-8 text-center">{ctaText}</div>
              <SubscriptionForm />
            </div>
          </div>
        </div>
      </div>
      <div className="bg-gray-100 pt-60 pb-32">
        <div className="mx-auto flex max-w-7xl flex-col items-center px-6">
          <PostPreviews posts={localizedPosts} />
          {/* TODO show more button */}
          {/* <button className="primary">En voir plus</button> */}
        </div>
      </div>
      <SubscribeCTABlock text={ctaText} />
    </Layout>
  );
}

export async function getStaticProps({
  locale,
  preview,
}: GetStaticPropsContext) {
  const blogPage = await getBlogPage({ locale, preview });
  const posts = await getAllPosts({ locale, preview });
  const menuParams = await getAllMenuPage({ locale, preview });

  return {
    props: {
      blogPage,
      posts: removeEntryCollectionCircularReferences(posts).items,
      menuParams,
    },
  };
}
